import React, { useCallback, useState } from "react";
import PathPickPoizonSellerCenterModal from "@/features/pathpick/components/product/PathPickPoizonSellerCenterModal";
import { PathPickMarket } from "@/features/pathpick/types";

export type OpenMarketExternal = (market: PathPickMarket, url: string) => void;

/**
 * 마켓 사이트로 나가는 동작 — 패스픽 상품 카드와 같은 규칙.
 * 크림은 공개 상품 페이지라 바로 새 창으로 열고, 포이즌은 판매자 로그인이 필요한 셀러센터라
 * 안내 모달을 한 번 거친다. 모달은 그리드에 하나만 두고 셀은 열기만 요청한다 —
 * 셀 안에 두면 ag-grid 가 셀을 다시 그릴 때 모달까지 사라진다.
 * (카드 보기는 패스픽 비교 블록이 같은 동작을 스스로 갖고 있어 이 훅을 쓰지 않는다)
 */
export function useMarketExternalLink() {
  const [sellerCenterUrl, setSellerCenterUrl] = useState<string | null>(null);

  const open = useCallback<OpenMarketExternal>((market, url) => {
    if (market === "POIZON") {
      setSellerCenterUrl(url);
      return;
    }
    window.open(url, "_blank", "noopener,noreferrer");
  }, []);

  const modal = (
    <PathPickPoizonSellerCenterModal
      isOpen={sellerCenterUrl !== null}
      onClose={() => setSellerCenterUrl(null)}
      url={sellerCenterUrl}
    />
  );

  return { open, modal };
}
